import { Injectable, Optional } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MessageService } from '../service/message.service';
import { Configurations } from '../../../Configuration';
import { TablePage } from '../table/table.page';

@Injectable({
	providedIn: 'root'
})
export class MenuService {

	endPoint: string;

	constructor(
		private messageService: MessageService,
		@Optional() config?: Configurations
	) {
		if (config.getProduction()) {
			this.endPoint = config.getMenuEndPoint();
		} else {
			this.endPoint = 'https://serengeti.aifrica.co.kr/api.menu/menu/v1/handle';
		}
	}

	search(
		filter = '',
		sortItem = 'createdDate', sortOrder = 'asc',
		pageNumber = 1, pageSize = 10): Observable<TablePage> {

		const menuUrl = this.endPoint + '/menu/';

		return this.messageService.query(menuUrl, new HttpParams()
			.set('name', filter)
			.set('sortItem', sortItem)
			.set('sortOrder', sortOrder)
			.set('page', pageNumber.toString())
			.set('size', pageSize.toString())
		).pipe(
			map(res =>  res)
		);
	}

	get(id: string): Observable<any> {
		const menuUrl = this.endPoint + '/menu/' + id + '/';

		return this.messageService.query(menuUrl).pipe(
			map(res =>  res)
		);
	}

	getByPath(path: string): Observable<any> {
		const menuUrl = this.endPoint + '/menu/list'

		return this.messageService.query(menuUrl, new HttpParams()
			.set('path', path)
		).pipe(
			map(res =>  res)
		);
	}

	roots(): Observable<any[]> {
		const menuUrl = this.endPoint + '/menu/roots/';

		return this.messageService.query(menuUrl);
	}

	subMenus(id: string, roles: string[]): Observable<any[]> {
		let menuUrl = this.endPoint + '/menu/' + id + '/list?';

		if (roles) {
			roles.forEach(role => {
				menuUrl += 'userRoles=' + role + '&';
			});
		}
		menuUrl += 'visibility=Visible';

		return this.messageService.query(menuUrl);
	}

	list(value: string): Observable<any> {
		const menuUrl = this.endPoint + '/list';

		return this.messageService.query(menuUrl, {
			name: value
		});
	}

	findUsers(value: string): Observable<any> {
		const menuUrl = this.endPoint + '/user/';

		return this.messageService.query(menuUrl, {
			name: value
		});
	}

	save(menu: any, id?: string) {
		let menuUrl = this.endPoint + '/';

		if (id) {
			menuUrl += id + '/';
			return this.messageService.put(menuUrl, menu);
		} else {
			if (menu.localParentId) {
				menuUrl += menu.localParentId + '/';
				return this.messageService.post(menuUrl, menu);
			} else {
				return this.messageService.post(menuUrl, menu);
			}
		}
	}

	delete(menus: any[]) {
		const url = this.endPoint + '/';

		return this.messageService.deleteWithBody(url, menus).pipe(
			map(res =>  res)
		);
	}

}
